export default "__VITE_ASSET__bdc8d815__"